import { environment } from '../../../environments/environment';

export interface MapsConfig {
  googleMapsApiKey: string;
  enableFallback: boolean;
  defaultZoom: number;
  defaultHeight: string;
}

export const mapsConfig: MapsConfig = {
  // Clé API Google Maps depuis l'environnement
  googleMapsApiKey: environment.googleMaps?.apiKey || '',

  // Afficher le fallback si l'API n'est pas disponible
  enableFallback: true,

  // Configuration par défaut depuis l'environnement
  defaultZoom: environment.googleMaps?.defaultZoom || 15,
  defaultHeight: environment.googleMaps?.defaultHeight || '200px',
};

// Instructions pour configurer Google Maps API :
// 1. Allez sur https://console.cloud.google.com/
// 2. Créez un nouveau projet ou sélectionnez un projet existant
// 3. Activez l'API Google Maps JavaScript
// 4. Créez des identifiants (clé API)
// 5. Dans les restrictions de la clé API, ajoutez vos domaines autorisés :
//    - localhost (pour le développement)
//    - Votre domaine de production
// 6. Remplacez la valeur de googleMapsApiKey ci-dessus
